import axios from '../../helpers/axios-setup';

export const returnToLabByStaff = ({ id, note }: { id: number; note: string }) =>
  axios.put(`/staff/lab-requests/return/${id}`, { text: note });
